// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotificationBell_bell-container__0kceV {
  display: flex;
  align-items: center;
}

.NotificationBell_bell-trigger__ZvQ4N {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}
.NotificationBell_bell-trigger__ZvQ4N:hover {
  background: var(--m-subtle-card-background-color);
}

.NotificationBell_bell-icon-wrapper__14A\\+v {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.NotificationBell_bell-icon__AyWD2 {
  font-size: 20px;
  color: var(--m-icon-color);
  transition: color 0.2s;
}
.NotificationBell_bell-trigger__ZvQ4N:hover .NotificationBell_bell-icon__AyWD2 {
  color: var(--m-primary);
}

.NotificationBell_bell-badge__MImLv {
  position: absolute;
  top: -6px;
  right: -6px;
  background: var(--m-danger, #ef4444);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  min-width: 16px;
  height: 16px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  line-height: 1;
}

.NotificationBell_bell-dropdown__a39T0 {
  padding: 0 !important;
  min-width: min(340px, 100vw - 16px);
  max-width: calc(100vw - 16px);
  box-sizing: border-box;
}

@media (max-width: 991.88px) {
  .NotificationBell_bell-container__0kceV {
    gap: 0;
  }
  .NotificationBell_bell-dropdown__a39T0 {
    min-width: 0;
    width: 100%;
  }
  .NotificationBell_bell-header__YGfM7 {
    flex-wrap: wrap;
    gap: 8px;
  }
  .NotificationBell_bell-item__WgKA0 {
    padding: 10px 12px;
  }
}
.NotificationBell_bell-header__YGfM7 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid var(--m-border-color);
}

.NotificationBell_bell-list__X7c2J {
  max-height: 320px;
  overflow-y: auto;
}

.NotificationBell_bell-empty__PmVzN {
  padding: 32px 16px;
  text-align: center;
  color: var(--m-text-light);
  font-size: 13px;
}

.NotificationBell_bell-item__WgKA0 {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--m-border-color);
  transition: background 0.15s;
}
.NotificationBell_bell-item__WgKA0:hover {
  background: var(--m-hover-color);
}
.NotificationBell_bell-item--unread__\\+3Cid {
  background: rgba(var(--m-primary-rgb, 59, 130, 246), 0.04);
}
.NotificationBell_bell-item__main__7H5G1 {
  flex: 1 1;
  min-width: 0;
}
.NotificationBell_bell-item__main__7H5G1 .NotificationBell_title-row__4Io2W {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 4px;
}
.NotificationBell_bell-item__main__7H5G1 .NotificationBell_title-row__4Io2W strong {
  flex: 1 1;
  min-width: 0;
  word-break: break-word;
  white-space: pre-wrap;
}
.NotificationBell_bell-item__main__7H5G1 .NotificationBell_title-row__4Io2W .NotificationBell_lozenge-wrapper__hlHPf {
  flex-shrink: 0;
}
.NotificationBell_bell-item__main__7H5G1 p {
  word-break: break-word;
  white-space: pre-wrap;
  margin-top: 0;
}
.NotificationBell_bell-item__actions__RHkQR {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex-shrink: 0;
}

.NotificationBell_bell-footer__nKSym {
  padding: 10px 14px;
  border-top: 1px solid var(--m-border-color);
  background: var(--m-subtle-card-background-color);
  text-align: center;
}
.NotificationBell_bell-footer__link__SaZAg {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--m-primary);
  text-decoration: none;
}
.NotificationBell_bell-footer__link__SaZAg:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/NotificationBell/NotificationBell.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AACF;AACE;EACE,iDAAA;AACJ;;AAGA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,eAAA;EACA,0BAAA;EACA,sBAAA;AAAF;AAEE;EACE,uBAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,oCAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AADF;;AAIA;EACE,qBAAA;EACA,mCAAA;EACA,6BAAA;EACA,sBAAA;AADF;;AAIA;EACE;IACE,MAAA;EADF;EAIA;IACE,YAAA;IACA,WAAA;EAFF;EAKA;IACE,eAAA;IACA,QAAA;EAHF;EAMA;IACE,kBAAA;EAJF;AACF;AAOA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,8CAAA;AALF;;AAQA;EACE,iBAAA;EACA,gBAAA;AALF;;AAQA;EACE,kBAAA;EACA,kBAAA;EACA,0BAAA;EACA,eAAA;AALF;;AAQA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,8CAAA;EACA,4BAAA;AALF;AAOE;EACE,gCAAA;AALJ;AAQE;EACE,0DAAA;AANJ;AASE;EACE,SAAA;EACA,YAAA;AAPJ;AASI;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,kBAAA;AAPN;AASM;EACE,SAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;AAPR;AAUM;EACE,cAAA;AARR;AAYI;EACE,sBAAA;EACA,qBAAA;EACA,aAAA;AAVN;AAcE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;AAZJ;;AAgBA;EACE,kBAAA;EACA,2CAAA;EACA,iDAAA;EACA,kBAAA;AAbF;AAeE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;AAbJ;AAeI;EACE,0BAAA;AAbN","sourcesContent":[".bell-container {\n  display: flex;\n  align-items: center;\n}\n\n.bell-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n\n  &:hover {\n    background: var(--m-subtle-card-background-color);\n  }\n}\n\n.bell-icon-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.bell-icon {\n  font-size: 20px;\n  color: var(--m-icon-color);\n  transition: color 0.2s;\n\n  .bell-trigger:hover & {\n    color: var(--m-primary);\n  }\n}\n\n.bell-badge {\n  position: absolute;\n  top: -6px;\n  right: -6px;\n  background: var(--m-danger, #ef4444);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n  min-width: 16px;\n  height: 16px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 3px;\n  line-height: 1;\n}\n\n.bell-dropdown {\n  padding: 0 !important;\n  min-width: min(340px, calc(100vw - 16px));\n  max-width: calc(100vw - 16px);\n  box-sizing: border-box;\n}\n\n@media (max-width: 991.88px) {\n  .bell-container {\n    gap: 0;\n  }\n\n  .bell-dropdown {\n    min-width: 0;\n    width: 100%;\n  }\n\n  .bell-header {\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .bell-item {\n    padding: 10px 12px;\n  }\n}\n\n.bell-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--m-border-color);\n}\n\n.bell-list {\n  max-height: 320px;\n  overflow-y: auto;\n}\n\n.bell-empty {\n  padding: 32px 16px;\n  text-align: center;\n  color: var(--m-text-light);\n  font-size: 13px;\n}\n\n.bell-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--m-border-color);\n  transition: background 0.15s;\n\n  &:hover {\n    background: var(--m-hover-color);\n  }\n\n  &--unread {\n    background: rgba(var(--m-primary-rgb, 59, 130, 246), 0.04);\n  }\n\n  &__main {\n    flex: 1;\n    min-width: 0;\n    \n    .title-row {\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n      gap: 8px;\n      margin-bottom: 4px;\n\n      strong {\n        flex: 1;\n        min-width: 0;\n        word-break: break-word;\n        white-space: pre-wrap;\n      }\n      \n      .lozenge-wrapper {\n        flex-shrink: 0;\n      }\n    }\n\n    p {\n      word-break: break-word;\n      white-space: pre-wrap;\n      margin-top: 0;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    flex-shrink: 0;\n  }\n}\n\n.bell-footer {\n  padding: 10px 14px;\n  border-top: 1px solid var(--m-border-color);\n  background: var(--m-subtle-card-background-color);\n  text-align: center;\n\n  &__link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: var(--m-primary);\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bell-container": `NotificationBell_bell-container__0kceV`,
	"bell-trigger": `NotificationBell_bell-trigger__ZvQ4N`,
	"bell-icon-wrapper": `NotificationBell_bell-icon-wrapper__14A+v`,
	"bell-icon": `NotificationBell_bell-icon__AyWD2`,
	"bell-badge": `NotificationBell_bell-badge__MImLv`,
	"bell-dropdown": `NotificationBell_bell-dropdown__a39T0`,
	"bell-header": `NotificationBell_bell-header__YGfM7`,
	"bell-item": `NotificationBell_bell-item__WgKA0`,
	"bell-list": `NotificationBell_bell-list__X7c2J`,
	"bell-empty": `NotificationBell_bell-empty__PmVzN`,
	"bell-item--unread": `NotificationBell_bell-item--unread__+3Cid`,
	"bell-item__main": `NotificationBell_bell-item__main__7H5G1`,
	"title-row": `NotificationBell_title-row__4Io2W`,
	"lozenge-wrapper": `NotificationBell_lozenge-wrapper__hlHPf`,
	"bell-item__actions": `NotificationBell_bell-item__actions__RHkQR`,
	"bell-footer": `NotificationBell_bell-footer__nKSym`,
	"bell-footer__link": `NotificationBell_bell-footer__link__SaZAg`
};
export default ___CSS_LOADER_EXPORT___;
